import classes from "../classes";
import expandable from "./higher-order/expandable";
import FormError from "./form-error";
import LightBox from "./light-box";
import { Map } from "immutable";
import pure from "./higher-order/pure";
import React from "react";
import states from "../states";
import TermsOfService from "./terms-of-service";

export default class SignUpForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    var { onSignUp } = this.props;
    e.preventDefault();
    var { firstName, lastName, emailAddress, screenName, password, state } = this.refs;
    onSignUp(firstName.value, lastName.value, emailAddress.value, screenName.value, password.value, state.value);
  }

  render() {
    var { communications } = this.props;

    var loading = communications.getIn(["signUp", "state"]) === "in progress";
    var errors = communications.getIn(["signUp", "error"]) || Map();

    var stateElems = states.filter(state => state.canSignUp).map(state => (
      <option key={state.abbr} value={state.abbr}>
        {state.name}
      </option>
    ));

    return (
      <form className="form--is-horizontal" onSubmit={this.onSubmit}>
        <div className="batch-g batch-g--padding batch-g--valign-center">

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="first-name">
              Name
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <div className="batch-g">
              <div className="batch-c-1-2 padding-right--is-10">
                <input className="form_input" id="first-name" name="first-name" placeholder="First" ref="firstName" type="text" />

                <FormError error={errors.get("first_name")} name="First Name" />
              </div>

              <div className="batch-c-1-2">
                <input className="form_input" id="last-name" name="last-name" placeholder="Last" ref="lastName" type="text" />

                <FormError error={errors.get("last_name")} name="Last Name" />
              </div>
            </div>
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="email-address">
              Email Address
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" id="email-address" name="email-address" placeholder="Email Address" ref="emailAddress" type="email" />

            <FormError error={errors.get("email")} name="Email Address" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="screen-name">
              Screen Name
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" id="screen-name" name="screen-name" placeholder="Screen Name" ref="screenName" type="text" />

            <FormError error={errors.get("username")} name="Screen Name" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="password">
              Password
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" id="password" name="password" placeholder="Password" ref="password" type="password" />

            <FormError error={errors.get("password")} name="Password" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="state">
              State
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <div className="batch-c-1-2 padding-right--is-10">
              <div className="form_input form_input--select form_input--is-block">
                <select id="state" name="state" ref="state">
                  <option disabled>
                    Select State
                  </option>

                  {stateElems}
                </select>
              </div>
            </div>

            <FormError error={errors.get("state")} name="State" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <div className="form_action">
              <input
                className={classes({
                  "btn": true,
                  "btn--primary": true,
                  "btn--is-loading": loading,
                })}
                disabled={loading}
                type="submit"
                value={loading ? "Processing" : "Create Account"} />
            </div>
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <Terms />
          </div>

        </div>
      </form>
    );
  }
}


var Terms = pure(expandable(function Terms({ expanded, toggle }) {
  var lightbox;
  if (expanded) {
    lightbox = (
      <LightBox onClose={toggle} tall title="Site Terms and Conditions">
        <div className="lightbox_body">
          <TermsOfService />
        </div>

        <div className="lightbox_footer">
          <button className="btn" onClick={toggle} type="button">
            Accept
          </button>
        </div>
      </LightBox>
    );
  }
  var toggleOnLink = e => {
    e.preventDefault();
    toggle();
  };
  return (
    <div>
      {lightbox}

      <p className="note-text">
        By signing up, you confirm that you are at least 18 years of age and agree to the
        {" "}

        <a className="link--is-underlined" href="/terms-and-conditions" onClick={toggleOnLink}>
          Terms and Conditions
        </a>

        {". " /* eslint-disable-line react/jsx-curly-brace-presence */ }
        Residents of certain states may not be able to play cash tournaments.
      </p>
    </div>
  );
}));
